module.exports = __webpack_public_path__ + "09b6de12b1063791ebbfed423c57ed38.png";